import { KdsLink, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";

import { type OrderItemPageActivityLogGraphicFileProps } from "./OrderItemPageActivityLogGraphicFile.types";

export const OrderItemPageActivityLogGraphicFile = ({
  deleted,
  file,
}: OrderItemPageActivityLogGraphicFileProps) => {
  const { t } = useTranslate();

  const infoIconLabel = deleted
    ? t("order.myOrdersItemDetails.activityFeed.action.infoIcon.refused")
    : t("order.myOrdersItemDetails.activityFeed.action.infoIcon.added");

  return (
    <div className="flex items-center gap-sp-xs2">
      <KdsText>
        {t("order.myOrdersItemDetails.activityFeed.action.graphicFile.intro")}
      </KdsText>

      {file && (
        <KdsLink href={file?.url} target="_blank" size="sm">
          {file?.name}
        </KdsLink>
      )}

      <KdsText>
        {t("order.myOrdersItemDetails.activityFeed.action.graphicFile.suffix")}
      </KdsText>
      <KdsText>{infoIconLabel}</KdsText>
    </div>
  );
};
